import OutlineSection from './OutlineSection';
import AssetsSection from './AssetsSection';
import './LeftPanel.css';

interface LeftPanelProps {
  activeSection: string;
  completedSections: string[];
  onSectionSelect: (sectionId: string) => void;
  onInsertAsset: (assetRef: string) => void;
  usedAssets?: string[];
  isReadOnly?: boolean;
}

export default function LeftPanel({
  activeSection,
  completedSections,
  onSectionSelect,
  onInsertAsset,
  usedAssets = [],
  isReadOnly = false,
}: LeftPanelProps) {
  return (
    <div className="left-panel">
      <OutlineSection
        activeSection={activeSection}
        completedSections={completedSections}
        onSectionSelect={onSectionSelect}
      />
      <AssetsSection onInsertAsset={onInsertAsset} usedAssets={usedAssets} isReadOnly={isReadOnly} />
    </div>
  );
}
